<template>
    <base-modal :closable="true" :name="name" :global="false" :adaptive="true" height="auto" :width="modalWidth">
        <div class="p-4">
            <iframe :src="src" class="w-full" :height="modalHeight" allow="autoplay"></iframe>
        </div>
    </base-modal>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        props: {
            src: {
                required: true,
            },
            name: {
                required: true,
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath', 'loggedIn']),

            modalWidth() {
                // 95 % of screen width (while integers)
                return Math.floor(window.innerWidth * 0.95);
            },

            modalHeight() {
                // 95% of screen height (while integers)
                return Math.floor(window.innerHeight * 0.95);
            }
        },

        methods: {
            ...mapMutations('modal', ['showModal', 'hideModal']),

            show(name) {
                this.showModal(name);
                this.hideModal(this.name);
            }
        }
    }
</script>
